// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Select from '../layout/CustomSelect';

import Notification from '../notification';

import { toggleModal, toggleSecondModalClose } from '../../storage/actions/modalsActions';
import { sendInviteFromWorkOrderToContractor } from '../../storage/actions/workOrdersActions';
import { dashboard as dashboardSelectStyle } from '../../utils/customSelectStyle';
import getWorkOrders from '../../utils/api/get/getWorkOrders';

const ContractorInviteSelectWorkOrder = ({
  modalState,
  currentApplicant,
  toggleModal,
  sendInviteFromWorkOrderToContractor,
  toggleSecondModalClose,
}) => {
  const [selectWorkOrder, setSelectWorkOrder] = useState('');
  const [workOrders, setWorkOrders] = useState([]);

  useEffect(() => {
    toggleModal(true, 'loader', true);

    getWorkOrders('', '', '', {}, {
      needFilterByRouterStatus: { published: true, draft: true },
      selectedWOTypes: ['draft', 'published'],
    })
      .then((allWorkOrders) => {
        setWorkOrders(
          allWorkOrders
            .filter((workOrder) => workOrder.status === 'published' || workOrder.status === 'draft')
            .map(({
              _id, WIN, customTagId: workOrderId, title,
            }) => ({
              value: _id,
              label: `${WIN} ${workOrderId} ${title}`,
            })),
        );
        toggleSecondModalClose('loader', true);
      });
  }, []);

  const closeModal = () => {
    toggleModal(false, 'contractorInviteSelectWorkOrder');
  };

  const inviteContractor = () => {
    if (!selectWorkOrder.value) {
      Notification('warning', { message: 'Please select  Work Order!' });
    } else {
      sendInviteFromWorkOrderToContractor({
        workOrdersId: [selectWorkOrder.value],
        contractorId: currentApplicant.contractor_details.userId,
      });
    }
  };

  if (!modalState.isOpen) {
    return null;
  }

  return (
    <div
      className="modal_block dashboard-modal dashboard-modal--centered modal_import showed"
      role="presentation"
      onClick={closeModal}
    >
      <div
        className="modal_container"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal_head">
          <div className="modal_title">Send Invite</div>
          <button
            type="button"
            className="close_btn"
            aria-label="close"
            onClick={closeModal}
          >
            ×
          </button>
        </div>
        <div className="modal_body">
          <div className="field_col">
            <label className="field_name" htmlFor="contractor-invite-wo-select">
              Work Order
            </label>
            <div className="dashboard-select-wrap">
              <Select
                inputId="contractor-invite-wo-select"
                isClearable
                isSearchable
                options={workOrders}
                value={selectWorkOrder}
                styles={dashboardSelectStyle}
                placeholder="Select..."
                classNames={{
                  control: ({ isFocused }) => (
                    `dashboard-select-control${isFocused ? ' dashboard-select-control--is-focused' : ''}`
                  ),
                  menu: () => 'dashboard-select-menu',
                  menuList: () => 'dashboard-select-menu-list',
                  option: ({ isFocused, isSelected }) => (
                    `dashboard-select-option${isFocused ? ' dashboard-select-option--focused' : ''}${isSelected ? ' dashboard-select-option--selected' : ''}`
                  ),
                  singleValue: () => 'dashboard-select-single-value',
                  placeholder: () => 'dashboard-select-placeholder',
                  valueContainer: () => 'dashboard-select-value-container',
                  input: () => 'dashboard-select-input',
                }}
                onChange={setSelectWorkOrder}
              />
            </div>
          </div>
        </div>
        <div className="modal_footer">
          <button
            type="button"
            className="dashboard-btn dashboard-btn--primary"
            aria-label="Invite"
            onClick={inviteContractor}
          >
            Invite
          </button>
          <button
            type="button"
            className="dashboard-btn dashboard-btn--secondary"
            aria-label="Cancel"
            onClick={closeModal}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  toggleModal,
  sendInviteFromWorkOrderToContractor,
  toggleSecondModalClose,
};

const mapStateToProps = (state) => ({
  currentApplicant: state.workOrder.currentApplicant,
  modalState: state.modalState.contractorInviteSelectWorkOrder,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContractorInviteSelectWorkOrder);
